export type ShareableItemTypeType =
  | 'SHAREABLE_ITEM_TYPE_UNKNOWN'
  | 'PRODUCT'
  | 'BRAND'
  | 'INVOICE'
  | 'BRAND_ORDER';

export enum ShareableItemType {
  SHAREABLE_ITEM_TYPE_UNKNOWN = 'SHAREABLE_ITEM_TYPE_UNKNOWN',
  PRODUCT = 'PRODUCT',
  BRAND = 'BRAND',
  INVOICE = 'INVOICE',
  BRAND_ORDER = 'BRAND_ORDER',
}
